export class CustomizerParams
{
    public hasForms: boolean = false;
    public hasFixtures: boolean = false;
	public isLimited: boolean = false;
	isParts: boolean;
}